import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { BackgroundImage } from '@application/Interfaces/Atoms/BackgroundImage/BackgroundImage'
import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { ImageNumberTitleDescriptionItemType } from '@application/Types/ComponentTypes'

import {
    BackgroundImageWrapper,
    Description,
    StoryBox,
    Title,
    Wrapper,
    Year,
} from './ImageNumberTitleDescriptionItem.styled'

export const ImageNumberTitleDescriptionItem = ({
    title,
    text,
    year,
    image,
    imageAnimation,
}: ImageNumberTitleDescriptionItemType): JSX.Element => {
    const storyImage = getImage(image.localFile) as IGatsbyImageData
    const WrapperTilt = imageAnimation ? Tilt : React.Fragment
    return (
        <WrapperTilt>
            <Wrapper>
                <BackgroundImageWrapper>
                    <BackgroundImage image={storyImage} title={image.alternativeText}>
                        <Year>{year}</Year>
                    </BackgroundImage>
                </BackgroundImageWrapper>

                <StoryBox>
                    <Title>{title}</Title>
                    <Description>{text}</Description>
                </StoryBox>
            </Wrapper>
        </WrapperTilt>
    )
}
